<template>
    <div ref="chatContainer" class="chat__wrapper">
        <status-bar v-pan="onPan" @close="closeChat" />
        <div class="chat_body" :class="[threadSwitch ? 'box-chat-right-full' : '']">
            <div class="chat_body_left">
                <div class="chat_body_left_header">
                    <div class="header_avatar__wrapper">

                        <avartar
                                class="header_avatar"
                                :name="userInfo.userName"
                                :size="36"
                        >
                            <div class="header_avatar--status"></div>
                        </avartar>
                        <span class="header_avatar_name">{{ userInfo.userName }}</span>
                    </div>
                    <search-people-groups-input v-model:text="threadSearchText" class="left_header_search_chat"/>
                </div>
                <div class="chat_body_left_body">
                    <thread-section :search-thread="threadSearchText"/>
                </div>
            </div>
            <div class="chat_body_right">
                <div v-if="!isConnectFail" class="chat_body_right--content">
                    <div class="chat_body_right_header">
                        <div class="header_content">
                            <div>
                                <div class="header_block">
                                    <div class="back" @click="backToList" :style="{ backgroundImage: 'url(' + require('@/assets/back-icon.png') + ')' }"></div>
                                    <span class="header_title">{{ currentThread.name }}</span>
                                </div>
                                <div class="header_subtitle">
                                    <dot-status :active="currentThread.online"></dot-status>
                                    <span style="margin-left: 4px">{{ contentSubtitle }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="chat_body_right_body ">
                        <message-section/>
                        <chat-input/>
                    </div>
                </div>
                <retry-button v-else/>
            </div>
            <connecting-dialog v-if="!isConnected && !isConnectFail"/>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import StatusBar from './StatusBar'
import ChatInput from './ChatInput'
import SearchPeopleGroupsInput from './SearchPeopleGroupsInput'
import DotLoader from './DotLoader'
import Spinner from './Spinner'
import Avartar from './Avartar'
import DotStatus from './DotStatus'
import ThreadSection from './ThreadSection'
import MessageSection from './MessageSection'
import { SET_OPEN_CHAT } from '../constants/mutation-types'
import * as timeUtils from '../utils/timeutils'
import ConnectingDialog from '../components/ConnectingDialog'
import RetryButton from './RetryButton'
import onResize from '../utils/resizeevent'

export default {
  name: 'ContainerChat',
  components: {
    RetryButton,
    MessageSection,
    ThreadSection,
    Spinner,
    DotLoader,
    StatusBar,
    ChatInput,
    SearchPeopleGroupsInput,
    Avartar,
    DotStatus,
    ConnectingDialog
  },
  data () {
    return {
      threadSearchText: '',
      currentOffsetX: 0,
      currentOffsetY: 0,
      clientHeight: 0,
      clientWidth: 0,
    }
  },
  computed: {
    ...mapGetters({
      threads: 'threads',
      currentThread: 'currentThread',
      messages: 'sortedMessages',
      isLoadingMessage: 'isLoadingMessage',
      isChineseText: 'isChineseText',
      isConnected: 'isConnected',
      isConnectFail: 'isConnectFail'
    }),
    ...mapState({
      userInfo: 'userInfo',
      threadSwitch: 'threadSwitch'
    }),
    isShowReadMessage: function () {
      const { currentThread, userInfo } = this
      if (currentThread.lastMessage)  {
        if (!currentThread.lastMessage.me) {
          return currentThread.lastMessage.isRead
        }
      }
      return false
    },
    contentSubtitle: function () {
      let text = ''
      if (this.currentThread.lastLoginTime) {
        const time = this.currentThread.lastLoginTime
        const isToday = timeUtils.isToday(time)
        const textTime = isToday ? timeUtils.formatHourMinutes(time, this.isChineseText)
          : timeUtils.formatDateHourMinutes(time, this.isChineseText)
        text = this.$t('lastLogin') + ' ' + textTime
      } else {
        text = this.$t('inactive')
      }
      return this.currentThread.online ? this.$t('active') : text
    },
    minHeight: function () {
      return (window.innerHeight - this.clientHeight) / 2
    },
    maxHeight: function () {
      return (window.innerHeight + this.clientHeight) / 2 - 32
    },
    minWidth: function () {
      return (window.innerWidth + this.clientWidth)/2 - 10
    },
    maxWidth: function () {
      return (window.innerWidth + this.clientWidth) / 2 - 10
    }
  },
  methods: {
    onPan: function (e) {
      e.preventDefault()
      const direction = e.direction
      const dragXOffset = e.deltaX
      const dragYOffset = e.deltaY
      if (this.$refs.chatContainer != null) {
        let transformX = this.currentOffsetX + dragXOffset
        let transformY = this.currentOffsetY + dragYOffset
        if (transformY < -this.minHeight) {
          transformY = -this.minHeight
        }
        if (transformY > this.maxHeight) {
          transformY = this.maxHeight
        }
        if (transformX < -this.minWidth) {
          transformX = -this.minWidth
        }
        if (transformX > this.maxWidth) {
          transformX = this.maxWidth
        }
        if (e.isFinal) {
          this.currentOffsetX = transformX
          this.currentOffsetY = transformY
        }
        let value = [
          'translate3d(' + transformX + 'px, ' + transformY + 'px, 0)',
          'scale(' + 1 + ', ' + 1 + ')',
          'rotate3d('+ 0 +','+ 0 +','+ 0 +','+  0 + 'deg)'
        ];

        value = value.join(" ");
        this.$refs.chatContainer.style.transform = value
      }
    },
    closeChat : function () {
      this.$store.commit(SET_OPEN_CHAT, false)
    },
    checkResizeContent: function () {
      this.clientHeight = this.$refs.chatContainer.clientHeight
      this.clientWidth = this.$refs.chatContainer.clientWidth
      const maxHeight = (window.innerHeight + this.clientHeight) / 2 + this.currentOffsetY
      const maxWidth = (window.innerWidth + this.clientWidth) / 2 + this.currentOffsetX
      this.$refs.chatContainer.style.maxWidth = maxWidth + 'px'
      this.$refs.chatContainer.style.maxHeight = maxHeight + 'px'
    },
    backToList: function (){
        this.$store.commit('threadSwitch', false)
    }
  },
  mounted () {
    this.checkResizeContent()
    //onResize(this.$refs.chatContainer, this.checkResizeContent)
  }
}
</script>

<style lang="scss">
.chat__wrapper {
    border: 1px solid #2c3e50;
    resize: both;
    overflow: hidden;
    width: 768px;
    height: 480px;
    min-height: 480px;
    min-width: 400px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border-radius: 5px;
    z-index: 12;
    .chat_body {
        display: flex;
        flex: 1 0 auto;
        height: calc(100% - 32px);
        position: relative;
        .chat_body_left {
            flex: 1 0 30%;
            background-color: #eceff1;
            height: 100%;
            display: flex;
            flex-direction: column;
            border-right: 1px solid grey;
            max-width: 300px;
            .chat_body_left_header {
                flex: 0 0 80px;
                display: flex;
                flex-direction: column;
                .header_avatar__wrapper {
                    display: flex;
                    align-items: center;
                    padding: 0 8px;
                    flex: 1 0 auto;
                    position: relative;
                    .header_avatar_name {
                        margin-left: 4px;
                        font-weight: bold;
                    }
                    .header_avatar {
                        position: relative;
                        .header_avatar--status {
                            width: 8px;
                            height: 8px;
                            border-radius: 4px;
                            background-color: green;
                            position: absolute;
                            bottom: 0;
                            right: 4px;
                        }
                    }
                }
                .left_header_search_chat {
                    align-self: flex-start;
                    height: 32px;
                    flex: 0 0 auto;
                    width: 100%;
                    padding: 0 8px;
                    margin-bottom: 2px;
                }
            }
            .chat_body_left_body {
                height: calc(100% - 80px);
            }
        }
        .chat_body_right {
            flex: 1 0 60%;
            background-color: #eceff1;
            height: 100%;
            display: flex;
            flex-direction: column;
            position: relative;
            .chat_body_right--content {
                width: 100%;
                height: 100%;
            }
            .chat_body_right_header {
                display: flex;
                align-items: center;
                height: 80px;
                flex: 0 0 auto;
                border-bottom: 1px solid lightgray;
                .header_content {
                    display: flex;
                    align-items: flex-start;
                    flex-direction: column;
                    .header_title {
                        font-weight: bold;
                        margin-left: 16px;
                    }
                    .header_subtitle {
                        font-size: 12px;
                        margin-left: 16px;
                        display: flex;
                        align-items: center;
                    }
                }
            }
            .chat_body_right_body {
                position: relative;
                flex: 1 0 auto;
                height: calc(100% - 80px);
                display: flex;
                flex-direction: column;
            }
        }
    }
}
@media only screen and (max-width: 991px){
    .chat__wrapper{
        width: 100vw!important;
        height: 100vh!important;
        min-width: unset!important;
        min-height: unset!important;
        max-width: 100vw !important;
        max-height: 100vh !important;
        .chat_body{
            .chat_body_right{
                display: none;
                .header_block{
                    display: flex;
                    .back{
                        width: 30px;
                        height: 25px;
                        background-repeat: no-repeat;
                        background-position: right;
                    }
                    .header_title{
                        line-height: 26px;
                        font-size: 18px;
                        margin-left: 4px!important;
                    }
                }
            }
            .chat_body_left{
                max-width: unset!important;
            }
            &.box-chat-right-full{
                .chat_body_left{
                    display: none;
                }
                .chat_body_right{
                    display: block;
                }
            }
        }
    }
}

</style>
